import { render, staticRenderFns } from "./Ligas.vue?vue&type=template&id=89b1b9f0&scoped=true"
import script from "./Ligas.vue?vue&type=script&lang=ts&setup=true"
export * from "./Ligas.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Ligas.vue?vue&type=style&index=0&id=89b1b9f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b1b9f0",
  null
  
)

export default component.exports